<apt-header [env]="envName">
  <apt-portal-switcher portalSwitcher [rolesAndPortals]="rolesAndPortals" [menuOffset]="32"></apt-portal-switcher>
</apt-header>

<apt-top-nav
  [homeRoute]="homeRoute"
  [settingsItems]="settingsItems"
  [userProfile]="userProfile"
  [logoutAction]="doLogout()"
  [showRoleSwitcher]="false"
>
  <apt-menu [menuItems]="menuItems"></apt-menu>
</apt-top-nav>
